import React, { forwardRef } from 'react';
import { Link, type LinkProps, useLocation } from 'react-router-dom';
import { localeFromPath, localizeIfTranslated } from '../src/i18n/supported';

/**
 * A <Link> that keeps the visitor inside their language.
 *
 * Drop-in replacement: import this as `Link` in components rendered on
 * localised routes. Paths that have no translated version (English-only
 * guides, comparisons, news) are left untouched, so no link can point at a
 * prefixed URL that does not exist.
 */
const LocaleLink = forwardRef<HTMLAnchorElement, LinkProps>(({ to, ...rest }, ref) => {
  const { pathname } = useLocation();
  const language = localeFromPath(pathname);
  const target = typeof to === 'string' ? localizeIfTranslated(language, to) : to;

  return <Link ref={ref} to={target} {...rest} />;
});

LocaleLink.displayName = 'LocaleLink';

export default LocaleLink;
